import type { StoryChapterDefInput } from '../schemas/progressionDefs';

/**
 * Granny's Story chapters (content-schemas §6.3, story-dialogue §3). Each chapter is a DialogueDef; this adds
 * album metadata and how it unlocks. Story items come only from unlock grants, so onSeen stays empty.
 */
export const CHAPTERS = [
  {
    id: 'ch0',
    order: 0,
    titleKey: 'story.ch0.title',
    albumKey: 'story.ch0.album',
    dialogueId: 'dlg_ch0',
    unlockedBy: { kind: 'newGame' },
    onSeen: [],
    skippable: true,
    autoPrompt: true,
  },
  {
    id: 'ch1',
    order: 1,
    titleKey: 'story.ch1.title',
    albumKey: 'story.ch1.album',
    dialogueId: 'dlg_ch1',
    // Granny's welcome letter inside box 5 (T07).
    unlockedBy: { kind: 'box', boxDefId: 'box_05_granny' },
    onSeen: [],
    skippable: true,
    autoPrompt: true,
  },
  {
    id: 'ch2',
    order: 2,
    titleKey: 'story.ch2.title',
    albumKey: 'story.ch2.album',
    dialogueId: 'dlg_ch2',
    unlockedBy: { kind: 'unlock', unlockId: 'unl_minimart' },
    onSeen: [],
    skippable: true,
    autoPrompt: true,
  },
  {
    id: 'ch3',
    order: 3,
    titleKey: 'story.ch3.title',
    albumKey: 'story.ch3.album',
    dialogueId: 'dlg_ch3',
    unlockedBy: { kind: 'unlock', unlockId: 'unl_photo_mode' },
    onSeen: [],
    skippable: true,
    autoPrompt: true,
  },
  {
    id: 'ch4',
    order: 4,
    titleKey: 'story.ch4.title',
    albumKey: 'story.ch4.album',
    dialogueId: 'dlg_ch4',
    unlockedBy: { kind: 'unlock', unlockId: 'unl_chapter_4' },
    onSeen: [],
    skippable: true,
    autoPrompt: true,
  },
  {
    id: 'ch5',
    order: 5,
    titleKey: 'story.ch5.title',
    albumKey: 'story.ch5.album',
    dialogueId: 'dlg_ch5',
    unlockedBy: { kind: 'unlock', unlockId: 'unl_chapter_5' },
    onSeen: [],
    skippable: true,
    // Plays when the player opens the special postcard pc_ch5_key in the mailbox (story-dialogue §3.5).
    autoPrompt: false,
    playsWithPostcard: 'pc_ch5_key',
  },
  // Studio NANO (studio-nano.md §7): opening the studio, then Tiếng lành Lv3 and Lv5.
  {
    id: 'ch6',
    order: 6,
    titleKey: 'story.ch6.title',
    albumKey: 'story.ch6.album',
    dialogueId: 'dlg_ch6',
    unlockedBy: { kind: 'unlock', unlockId: 'unl_studio' },
    onSeen: [],
    skippable: true,
    autoPrompt: true,
  },
  {
    id: 'ch7',
    order: 7,
    titleKey: 'story.ch7.title',
    albumKey: 'story.ch7.album',
    dialogueId: 'dlg_ch7',
    unlockedBy: { kind: 'unlock', unlockId: 'unl_studio_lv3' },
    onSeen: [],
    skippable: true,
    autoPrompt: true,
  },
  {
    id: 'ch8',
    order: 8,
    titleKey: 'story.ch8.title',
    albumKey: 'story.ch8.album',
    dialogueId: 'dlg_ch8',
    unlockedBy: { kind: 'unlock', unlockId: 'unl_studio_lv5' },
    onSeen: [],
    skippable: true,
    autoPrompt: true,
  },
] as const satisfies readonly StoryChapterDefInput[];
